import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import BottomNav from "./BottomNav";
import { useOrganization } from "@/hooks/useOrganization";
import { useUnreadNotificationsCount } from "@/hooks/useUnreadNotificationsCount";
import { useTranslation } from "react-i18next";

export default function MobileLayout({ children }: { children: ReactNode }) {
  const { organization } = useOrganization();
  const unread = useUnreadNotificationsCount();
  const { t } = useTranslation("common");

  return (
    <div className="min-h-screen bg-background">
      {/* G-003/R-6 (decision 7a): slim player top bar — club identity + bell → /notifications */}
      <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="mx-auto flex h-12 max-w-lg items-center justify-between px-4">
          <Link to="/" className="flex min-w-0 items-center gap-2">
            {organization?.logo_url && (
              <img src={organization.logo_url} alt="" className="h-6 w-6 rounded object-cover" />
            )}
            <span className="truncate text-sm font-semibold">{organization?.name ?? ""}</span>
          </Link>
          <Link
            to="/notifications"
            aria-label={t("nav.notifications")}
            className="relative -mr-2 flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground hover:text-foreground transition-colors"
          >
            <Bell className="h-5 w-5" />
            {unread > 0 && (
              <span className="absolute right-0.5 top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-0.5 text-[8px] font-bold text-destructive-foreground">
                {unread > 99 ? "99+" : unread}
              </span>
            )}
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-lg px-4 pt-6 pb-20">
        {children}
      </main>
      <BottomNav />
    </div>
  );
}
